module.exports = __webpack_public_path__ + "img/hair_back_female_straight_short.b52fbe8a.png";